// src/store/slices/busStopsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchTerm: '',
  filters: {
    busStandCode: '',
    stateCode: '',
    zoneCode: '',
    busStandName: '',
  },
  busStops: [],
  hasSearched: false,
  initialLoad: true,
};

const busStopsSlice = createSlice({
  name: 'busStops',
  initialState,
  reducers: {
    setSearchTerm(state, action) {
      state.searchTerm = action.payload;
    },
    setFilters(state, action) {
      state.filters = action.payload;
    },
    setBusStops(state, action) {
      state.busStops = action.payload;
    },
    setHasSearched(state, action) {
      state.hasSearched = action.payload;
    },
    setInitialLoad(state, action) {
      state.initialLoad = action.payload;
    },
    resetBusStopsSearch() {
      return { ...initialState };
    },
  },
});

export const {
  setSearchTerm,
  setFilters,
  setBusStops,
  setHasSearched,
  setInitialLoad,
  resetBusStopsSearch,
} = busStopsSlice.actions;

export default busStopsSlice.reducer;